<template>
    <div class="participations" v-if="!isLoading">
      <span style="font-size: 10px; margin-right: 10px;">Kontigentstand prüfen</span>
      {{150000 - this.totalParticipations}}
    </div>
</template>
<script>
import axios from 'axios';

export default {
  name: "participations",
  data() {
    return {
      totalParticipations: 0,
      isLoading: true
    }
  },
  mounted() {
    axios.post('https://js-backend.justsnap.eu/api/participationCount', {
      campaignId: this.$store.state.campaignId
    })
    .then(({ data }) => {
      this.totalParticipations = data.totalParticipation;
      this.isLoading = false
    })
  }
}
</script>
<style scoped>
.participations {
  text-align: center;
  justify-content: space-between;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 22px;
  color: var(--brand-color);
  padding: 0 15px;
  margin-bottom: 10px;
  margin-top: 20px;
  max-width: 400px;
}
img {
    width: 100px;
}
</style>
